import { perguntas } from '../perguntas/lista-perguntas';

export const somaValorQuestionario = (values) => {
  let somaValores = 0;
  Object.keys(values).forEach((item) => {
    if (typeof values[item] === 'number') {
      somaValores += values[item];
    }
  });
  return parseInt(somaValores, 10);
};

export const obtemMaiorValorQ5 = (values) => {
  const valores = perguntas[4].opcoes;
  return Math.max(
    values.questao5_1 ? valores[0].value : 0,
    values.questao5_2 ? valores[1].value : 0,
    values.questao5_3 ? valores[2].value : 0,
    values.questao5_4 ? valores[3].value : 0
  );
};
